import { getRouteApi } from '@tanstack/react-router';

const _tourRoute = getRouteApi(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view'
);

export const VirtualTourBreadcrumb = () => {
  return <span>Virtual Tour Demo</span>;
};
